<template>
  <div>
    <v-layout row container justify-center>

      <v-dialog v-model="dialog" persistent max-width="800">
        <v-card light class="pt-2">

          <v-btn icon absolute right @click="closeDialog">
            <v-icon>close</v-icon>
          </v-btn>

          <span class="partido-title">Comentarios pre-partido</span>
          <div style="display: flex; align-self: flex-start; margin-left: 25px;">
            <span style="font-size: 1.2em;"><b>Título:</b> {{ comentarioPrePartido.title }}</span>
          </div>
          <ChatComentarios :comentarioPrePartido="comentarioPrePartido"></ChatComentarios>
          <v-card flat style="border-top: 1px solid #e0e0e0;">
            <v-card-text style="padding: 8px 12px;">

              <v-layout row align-end>
                <v-flex>
                  <v-textarea v-model="nuevoMensaje" style="padding-top:0; margin-top:0"
                    placeholder="Escribe tu mensaje..." rows="1" auto-grow hide-details required>
                  </v-textarea>
                </v-flex>

                <div class="d-flex align-center pb-1"> <v-btn icon flat color="grey darken-1" class="ma-0 ml-2"
                    title="Adjuntar archivo" @click="openFileDirectory" :disabled="saving">
                    <v-icon>attach_file</v-icon>
                  </v-btn>

                  <v-btn fab small depressed color="primary" class="ma-0 ml-2" title="Enviar mensaje"
                    @click="uploadAllFiles" :disabled="saving">
                    <v-icon color="white" class="pl-1">send</v-icon>
                  </v-btn>
                </div>
              </v-layout>

              <div style="width: 100%; max-height: 150px; overflow-y: auto; overflow-x: hidden;">
                <AttachFileComentarioFicha class="mt-2" ref="fileInput" @upload="uploadFiles">
                </AttachFileComentarioFicha>
              </div>

            </v-card-text>
          </v-card>
        </v-card>
      </v-dialog>

    </v-layout>
  </div>
</template>

<script>
import ChatComentarios from './ChatComentarios.vue'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import AttachFileComentarioFicha from '../../../common/ui/AttachFileComentarioFicha'
import { s3UploadMixin } from '../../../mixins/s3UploadMixin'

export default {
  mixins: [validationMixin, s3UploadMixin],

  validations: {
    nuevoMensaje: { required }
  },

  components: {
    ChatComentarios,
    AttachFileComentarioFicha
  },

  props: {
    partidoDescription: null,
    partidoId: null,
    consultaId: null,
    comentarioId: null
  },

  data () {
    return {
      loading: true,
      consulta: {},
      previousAuthor: '',
      history: [],
      derivar: false,
      showHistoryDialog: false,
      dialog: false,
      comentarioPrePartido: {},
      files: [],
      items: [],
      file: null,
      nuevoMensaje: '',
      saving: false
    }
  },

  methods: {
    limpiarFormulario () {
      this.nuevoMensaje = ''

      this.$v.$reset()

      this.files = []

      this.assets = []

      if (this.$refs.fileInput) {
        this.$refs.fileInput.cleanContent()
        this.postSubmit()
      }
    },
    uploadFiles (newFiles) {
      this.files = newFiles
    },
    openFileDirectory () {
      this.$refs.fileInput.onPickFile()
    },
    submit () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.saving = true
        const payload = {
          texto: this.nuevoMensaje,
          padre: this.comentarioId
        }
        this.axios
          .post('/informe-auditoria/comentario-pre-partido-respuesta/new', payload)
          .then((response) => {
            let newMessage = response.data
            if (this.assets.length > 0) {
              this.axios
                .put('/informe-auditoria/comentario-pre-partido/upload-s3/' + newMessage.id, { assets: this.assets })
                .then((responseS3) => {
                  this.limpiarFormulario()
                  this.fetchData()
                  this.saving = false
                })
                .catch(error => { this.$store.commit('setErrorMsg', error) })
            } else {
              this.limpiarFormulario()
              this.fetchData()
              this.saving = false
            }
          })
          .catch(error => {
            this.$store.commit('setErrorMsg', error)
            this.saving = false
          })
      }
    },
    fetchData () {
      this.axios
        .get(`informe-auditoria/comentario-pre-partido/${this.comentarioId}`)
        .then(response => {
          this.comentarioPrePartido = response.data
          this.loading = false
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    differentAuthor (currentAuthor) {
      return (this.consulta.autor.username !== currentAuthor.username)
    },
    addMessage (newMessage) {
      this.consulta.mensajes.push(newMessage)
      this.consulta.canReply = true
      this.$router.go()
    },
    updateConsulta () {
      this.hideEdit()
      this.$router.go()
    },
    getAttachmentName (attachment) {
      return attachment.split('/').slice(-1).pop()
    },
    showDialog () {
      this.dialog = true
      this.fetchData()
    },
    closeDialog () {
      this.dialog = false
      this.$emit('closeComentarioPopUp')
    }
  },

  computed: {
    showResponseArea () {
      if (this.consulta.hasOwnProperty('canReply')) {
        return this.consulta.canReply
      }
      return false
    },
    isOpen () {
      return this.consulta.estado !== 'Cerrada'
    },
    isDerivada () {
      return this.consulta.derivadaFrom !== ''
    },
    nuevoMensajeErrors () {
      const errors = []
      if (!this.$v.nuevoMensaje.$dirty) return errors
      !this.$v.nuevoMensaje.required && errors.push('El cuerpo es requerido.')
      return errors
    }
  },

  created () {
  },
  mounted () {
    this.showDialog()
  }
}

</script>

<style>
.subheadline {
  color: lightslategray;
  font-size: 1.4em;
  color: rgb(99, 95, 95);
}

.partido-title {
  color: lightslategray;
  font-size: 1.7em;
  color: rgb(60, 145, 197);
  padding-left: 1em;
  padding-top: 1em
}

a {
  color: #1787c9;
}

.center {
  text-align: center;
}

.btn-volver {
  margin-top: 10px;
}
</style>
